import { render } from "./IconTrash.vue?vue&type=template&id=73968f44&ts=true"
import script from "./IconTrash.vue?vue&type=script&lang=ts"
export * from "./IconTrash.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__